import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { authApi } from "@/lib/api";
import { queryKeys } from "./keys";

export function useSessions() {
  return useQuery({
    queryKey: queryKeys.sessions.list,
    queryFn: authApi.listSessions,
  });
}

export function useRevokeAllOtherSessions() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: authApi.revokeAllOtherSessions,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: queryKeys.sessions.list }),
  });
}
